import Table from "Shared/components/DataTable/Table"
import Modal from "Shared/components/Modal/Modal"
import restClient from "Shared/hooks/restClient"

const NotesWidget = () => {
  const target = useSel((s) => s.target)
  const [modalOpen, setModalOpen] = useState(false)
  const [noteBody, setNoteBody] = useState('')
  const [editingNoteId, setEditingNoteId] = useState(null)
  const [refreshTable, setRefreshTable] = useState(false)

  const isTargetValid = target && Object.keys(target).length > 0 && target.id

  if (!isTargetValid) {
    return <div>Loading...</div>
  }

  const saveNote = () => {
    const payload = {
      content: noteBody,
      ...(editingNoteId && { note_id: editingNoteId })
    }
    
    restClient.post(`/api/targets/${target.id}/notes/save`, payload).then(() => {
      setNoteBody('')
      setEditingNoteId(null)
      setModalOpen(false)
      setRefreshTable(prev => !prev)
    })
  }

  const handleTableClick = (e) => {
    if(e.target.classList.contains('edit-target-note-button')) {
      const noteId = e.target.dataset.noteId
      setEditingNoteId(noteId)
      setModalOpen(true)
      restClient.get(`/api/targets/${target.id}/notes/${noteId}`).then(({ data }) => {
        setNoteBody(data.content)
      })
    }
  }

  const openAddModal = () => {
    setEditingNoteId(null)
    setNoteBody('')
    setModalOpen(true)
  }

  const tableProps = {
    key: refreshTable,
    table: 'targetNotes',
    language: { emptyTable: "No notes available." },
    scope: { target_id: target.id },
    onClick: handleTableClick,
    hideSearch: true,
  }

  return (
    <>
      <p className="larger bold no-margin-top">Notes</p>
      <Table {...tableProps} />
      <button className="button small primary margin-top" type="button" onClick={openAddModal}>Add note</button>
      <Modal
        open={modalOpen}
        title={editingNoteId ? "Edit Note" : "Add Note"}
        onCancel={() => setModalOpen(false)}
      >
        <div>
          <textarea
            className="full-width"
            rows={5}
            value={noteBody}
            onChange={(e) => setNoteBody(e.target.value)}
          />
          <button
            className="button primary margin-top half"
            type="button"
            onClick={saveNote}
            disabled={noteBody.trim() === ''}
          >
            {editingNoteId ? "Update note" : "Save note"}
          </button>
        </div>
      </Modal>
    </>
  )
}

export default NotesWidget
